import { Dropdown } from "Components/Shared/Inputs/Dropdown";
import type { PayPointBaseDto } from "Infrastructure/Api/Api";
import { BOTTOM_MENU_HEIGHT } from "Components/Layout/Menu/BottomMenu";
import SensorsIcon from "@mui/icons-material/Sensors";
import SensorsOffIcon from "@mui/icons-material/SensorsOff";
import { Box } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";
import { activePaypointsFilter } from "Components/Paypoints/utils";
import type { LookupItem } from "Models/LookupItem";

type Props = {
  paypoints?: Array<PayPointBaseDto>;
  selectedPaypoint: PayPointBaseDto | null;
  setSelectedPaypoint: (paypoint: PayPointBaseDto | null) => void;
  isNoPaypointChoiceExcluded?: boolean;
};

export const PaypointDropdown = ({
  paypoints = [],
  selectedPaypoint,
  setSelectedPaypoint,
  isNoPaypointChoiceExcluded,
}: Props) => {
  const { t } = useResource();

  const activePaypoints = paypoints.filter(activePaypointsFilter);

  const options: Array<LookupItem> = [
    ...(isNoPaypointChoiceExcluded
      ? []
      : [{ Value: "", Name: t(Resources.Paypoint.NoPaypoint) }]),
    ...activePaypoints.map(({ publicID, name, nfcCardNo }) => ({
      Value: publicID,
      Name: name || t(Resources.Paypoint.UnnamedPaypoint),
      disabled: !nfcCardNo,
      Icon: (
        <Box
          sx={{
            opacity: 0.9,
            display: "flex",
            alignItems: "center",
          }}
        >
          {nfcCardNo ? (
            <SensorsIcon sx={{ fontSize: "1.4rem" }} />
          ) : (
            <SensorsOffIcon sx={{ fontSize: "1.4rem" }} />
          )}
        </Box>
      ),
    })),
  ];

  return (
    <Dropdown
      isBorderless
      name="paypoint"
      options={options}
      value={selectedPaypoint?.publicID || ""}
      onChange={(value) => {
        const selected = paypoints.find((p) => p.publicID === value);
        setSelectedPaypoint(selected || null);
      }}
      placeholder={t(Resources.Paypoint.NoPaypointPlaceholder)}
      menuProps={{
        PaperProps: {
          sx: {
            mt: [`-${BOTTOM_MENU_HEIGHT}`, `-${BOTTOM_MENU_HEIGHT}`, 0],
            maxHeight: "50%",
            "& .MuiMenuItem-root .MuiBox-root": {
              fontWeight: 400,
            },
          },
        },
      }}
    />
  );
};
